import { FormSubmissionDetailTaxApi } from '@features/forms/types/formSubmissionDetailApi';
import { SubmissionTaxDetails } from '@features/forms/types/submissionDrawer';

import { parseSubmissionPaymentAmount } from './parseSubmissionPaymentAmount';

export const mapSubmissionTaxDetails = (
  tax?: FormSubmissionDetailTaxApi
): SubmissionTaxDetails | undefined => {
  if (!tax) {
    return undefined;
  }

  const cgstAmount = parseSubmissionPaymentAmount(tax.cgst_amount);
  const sgstAmount = parseSubmissionPaymentAmount(tax.sgst_amount);
  const igstAmount = parseSubmissionPaymentAmount(tax.igst_amount);
  const totalGstAmount =
    parseSubmissionPaymentAmount(tax.total_gst_amount) ||
    cgstAmount + sgstAmount + igstAmount;

  if (
    cgstAmount === 0 &&
    sgstAmount === 0 &&
    igstAmount === 0 &&
    totalGstAmount === 0
  ) {
    return undefined;
  }

  const cgstPercent = parseSubmissionPaymentAmount(tax.cgst);
  const sgstPercent = parseSubmissionPaymentAmount(tax.sgst);
  const igstPercent = parseSubmissionPaymentAmount(tax.igst);

  return {
    cgstPercent: cgstPercent > 0 ? cgstPercent : undefined,
    sgstPercent: sgstPercent > 0 ? sgstPercent : undefined,
    igstPercent: igstPercent > 0 ? igstPercent : undefined,
    cgstAmount: cgstAmount > 0 ? cgstAmount : undefined,
    sgstAmount: sgstAmount > 0 ? sgstAmount : undefined,
    igstAmount: igstAmount > 0 ? igstAmount : undefined,
    totalGstAmount
  };
};

export default mapSubmissionTaxDetails;
